import React from "react";
import { LogRenderContext } from "../LogRenderer";
import Deleted from "../common/Deleted";

const CampaignDeleted = () => {
  const { log } = React.useContext(LogRenderContext);
  const { name, id } = log.dataSnapshot.campaign;
  const { updatedBy, updatedAt } = log.changedFields?.campaign || {};
  return <Deleted name={name} id={id} updatedBy={updatedBy} updatedAt={updatedAt} />;
};

export default CampaignDeleted;
